<div class="delete-popover-container">
  <div class="delete-popover-heading">
    <h3 class="delete-title">Delete Plotting Point</h3>
    <button class="close-button">
      <mat-icon class="close-icon" mat-dialog-close>close</mat-icon>
    </button>
  </div>
  <div class="content-background">
    <div class="deletepopover-text">
      <h6 class="deletepopover-inner-text">Are you sure you want to</h6>
      <h6 class="deletepopover-inner-text"> delete plotting point?</h6>
    </div>
    <div class="btn-container">
      <button class="cancel-btn" mat-dialog-close>Cancel</button>
      <button class="submit-btn" [mat-dialog-close]="true" (click)="closeDialog()">Submit</button>
    </div>
  </div>
</div>